import { Box } from '@mui/material'
import React from 'react'
import { observer } from 'mobx-react-lite'
import { SwitchField } from 'shared/ui'
import { AdvancedScheduling } from 'shared/ui/Schedule/ui/AdvancedScheduling'
import { SendingHours } from 'shared/ui/Schedule/ui/SendingHours'
import { useImmediatelyContext } from '../context/immediatelyContext'

export const ImmediatelyContent = observer(() => {
  const {
    advancedSchedulingStore,
    sendingHoursStore,
    toggleUseContactTimezone,
    isUseContactTimezone,
  } = useImmediatelyContext()
  return (
    <>
      {sendingHoursStore && (
        <SendingHours
          store={sendingHoursStore}
          expandedBoxProps={{
            borderBottom: '1px solid var(--border-neutral-default)',
          }}
        />
      )}
      <AdvancedScheduling
        store={advancedSchedulingStore}
        expandedBoxProps={{
          borderBottom: '1px solid var(--border-neutral-default)',
        }}
      />
      {advancedSchedulingStore.isEnabled && (
        <Box
          padding={1}
          sx={{ background: 'var(--background-neutral-subtle)' }}
          borderRadius={'0 0 8px 8px'}
        >
          <SwitchField
            variant={'gray'}
            value={isUseContactTimezone}
            onClick={toggleUseContactTimezone}
            labelProps={{
              label: {
                leftIcon: 'userFilled',
                text: 'Use contact timezone',
              },
              questionTooltipProps: {
                label:
                  "Sends messages based on the contact's time zone, determined by their phone number's area code.",
                width: 240,
                breakWord: true,
              },
            }}
            buttonProps={{ paddingInline: '20px 16px' }}
          />
        </Box>
      )}
    </>
  )
})
